module.exports = __webpack_public_path__ + "img/Group 3.28152b7e.svg";